export default __webpack_public_path__ + "static/media/NorthAmerica_04.090e6d28.png";